type GeocodeStatusValue = "ok" | "failed" | "unchecked";

const config: Record<GeocodeStatusValue, { label: string; color: string; bg: string; dot: string }> = {
  ok: {
    label: "Geofence OK",
    color: "#1b5e20",
    bg: "#e8f5e9",
    dot: "#4caf50",
  },
  failed: {
    label: "Can't Geocode",
    color: "#b71c1c",
    bg: "#ffebee",
    dot: "#e53935",
  },
  unchecked: {
    label: "Not Checked",
    color: "#424242",
    bg: "#f5f5f5",
    dot: "#9e9e9e",
  },
};

export const GeocodeStatus = (rowData: { geocodeStatus?: GeocodeStatusValue }) => {
  const status = rowData.geocodeStatus ?? "unchecked";
  const { label, color, bg, dot } = config[status] ?? config.unchecked;

  return (
    <span
      title={
        status === "failed"
          ? "Address couldn't be located on Google Maps. Geofencing is disabled for this job."
          : undefined
      }
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        background: bg,
        color,
        borderRadius: 20,
        padding: "3px 10px",
        fontSize: 11,
        fontWeight: 700,
        whiteSpace: "nowrap",
      }}
    >
      <span
        style={{
          width: 7,
          height: 7,
          borderRadius: "50%",
          background: dot,
          display: "inline-block",
          flexShrink: 0,
        }}
      />
      {label}
    </span>
  );
};
